import { css } from 'linaria';

export const unableToBuyNote = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  border-top: 1px solid var(--control-minor);

  padding-top: var(--space-250);
  padding-bottom: var(--space-100);

  & > span {
    margin-left: var(--space-100);
  }
  button {
    margin-left: auto;
  }
`;

export const isAvailableNote = css`
  margin-top: 36px;
  margin-bottom: 12px;
`;

export const showSimilarButton = css`
  margin-left: auto;
`;
